import { useEffect, useCallback } from 'react';
export default function useKeyDown(element, keyCode, onPress) {
  const keyDownHandler = useCallback(e => {
    if (e.code === keyCode) {
      onPress();
    }
  }, [keyCode, onPress]);
  useEffect(() => {
    if (!element) return () => null;
    element.addEventListener('keydown', keyDownHandler, false);
    return () => {
      element.removeEventListener('keydown', keyDownHandler, false);
    };
  }, [element, keyDownHandler]);
}
//# sourceMappingURL=useKeyDown.js.map